// extracted by mini-css-extract-plugin
export const thumb = "article-preview-module--thumb--1gZsV";
export const text = "article-preview-module--text--33wyY";
export const title = "article-preview-module--title--1Uq8k";
export const excerpt = "article-preview-module--excerpt--101xZ";